module.exports = __webpack_public_path__ + "img/boxBlack.103e7d88.svg";